/**
 * Generates a short, unique load reference number.
 * Format: LR-XXXXXX (6 uppercase alphanumeric chars)
 * Example: LR-7K3M9X
 */
export const generateLoadNumber = (): string => {
  const timePart = Date.now().toString(36).slice(-4);
  const randPart = Math.random().toString(36).slice(2, 4);
  return `LR-${(timePart + randPart).toUpperCase().slice(0, 6)}`;
};
